<script lang="ts">
    import { _ } from "svelte-i18n"

    import { lang, location, overlay } from "../../../store"
    import { spaNavigate } from "../../../functionTools/routing"
    import AnimatingMoreArrow from "../../widgets/AnimatingMoreArrow.svelte"
    let { initialSearch = "" } = $props()
    let search: string = $state(initialSearch)
    let active = $state(false)
</script>

<div class="headline">{$_("search.headline")}</div>
<form
    class="form"
    onsubmit={(e) => {
        e.preventDefault()
        if ($location.path.includes("search")) {
            spaNavigate("/search?" + encodeURIComponent(search))
            window.location.reload()
        } else spaNavigate("/search?" + encodeURIComponent(search))

        $overlay.show = false
    }}
>
    <div class="input_holder">
        <input type="text" name="search" placeholder={$_("search.placeholder")} bind:value={search} required />

        <button
            aria-label="search"
            class="morebtn more dark large"
            onmouseenter={() => (active = true)}
            onmouseleave={() => (active = false)}
        >
            <span>{$_("search.search")}</span>

            <AnimatingMoreArrow {active} color={"dark"} />
        </button>
    </div>
</form>

<style lang="less">
    .headline {
        margin-bottom: 20px;
    }
    form {
        max-width: 400px;
    }

    .form {
        width: 100%;
        .input_holder {
            display: flex;
            align-items: center;
            input {
                flex-grow: 1;
                border-bottom: 1px solid var(--stroke-100);
                margin-right: 1.2rem;
                padding-bottom: 0.2rem;
                height: 100%;
            }

            button {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
</style>
